if (!customElements.get('ld-brand-tabs')) {
  customElements.define('ld-brand-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.nav = this.querySelector('[data-tab-nav]');
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      if (!this.nav || !this.tabs.length || this.tabs.length !== this.panels.length) return;
      this.initialized = true;
      this.nav.setAttribute('role', 'tablist');
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('role', 'tab');
        const panel = this.panels[i];
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        panel.tabIndex = 0;
      });
      this.onClick = (event) => {
        const tab = event.target.closest('[data-tab]');
        if (tab && this.nav.contains(tab)) this.select(this.tabs.indexOf(tab));
      };
      this.onKey = (event) => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.select(next);
        this.tabs[next].focus();
      };
      this.onBlockSelect = (event) => {
        const panel = event.target.closest('[data-panel]');
        if (panel && this.contains(panel)) this.select(this.panels.indexOf(panel));
      };
      this.nav.addEventListener('click', this.onClick);
      this.nav.addEventListener('keydown', this.onKey);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      this.select(0);
      this.dataset.ready = 'true';
    }
    select(index) {
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        this.panels[i].hidden = i !== index;
      });
    }
    disconnectedCallback() {
      if (!this.initialized) return;
      this.nav.removeEventListener('click', this.onClick);
      this.nav.removeEventListener('keydown', this.onKey);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.initialized = false;
    }
  });
}
